export const isYMEnabled = (): boolean => {
  return process.env.REACT_APP_IS_YM_ENABLED === 'true';
};
